import { useSelector } from 'react-redux';
import { Container } from '../../models';
import { selectWorkingContainer } from '../../selectors';

export const useWorkingContainer = (): Container | undefined => {
  const container = useSelector(selectWorkingContainer);

  return container;
};
